<template>
    <el-table ref="tableBody"
      height="100%"
      :data="queryData"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="日期"
        width="180">
      </el-table-column>
      <el-table-column
        v-for="item of deviceList" :key="item" :prop="item" :label="textMap ? textMap.get(item) : item"
      >
        <template slot-scope="scope">
          <span>{{scope.row[item]}}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!disableUnit"
        prop="unit"
        label="单位"
        width="180">
      </el-table-column>
    </el-table>
</template>

<script>
export default {
  name: 'QueryTable',
  props: ['queryData', 'deviceList', 'textMap', 'disableUnit'],
  data () {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    }
  }
}
</script>

<style lang="scss">
.table .table-container {
  overflow: auto;
}
</style>
